import { useMemo } from 'react';
import { useLocation } from "react-router-dom";
import { CustomerFormValues } from '../../models/customer';
import { AccountsReceivable } from '../../models/accountsReceivable';
import { showAlertBasedOnThreshold } from './functions';

export default function useQuery() {
  return new URLSearchParams(useLocation().search);
}


export function useShowCreditLimitMsg(
  selectedCustomer: CustomerFormValues | undefined,
  selectedAccountsReceivable: AccountsReceivable | undefined,
  amountDue?: number,
) {    
  const showCreditLimitAlertMessage = useMemo(() => {
    const leftToUse = (selectedAccountsReceivable?.creditLimit ?? 0) - (selectedAccountsReceivable?.balanceDue ?? 0);
    return (
      selectedCustomer &&
      selectedAccountsReceivable &&
      showAlertBasedOnThreshold(
        selectedAccountsReceivable.creditLimit,
        0.0,
        leftToUse - (amountDue ?? 0.0)
      )
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCustomer, selectedAccountsReceivable]);
  return {
    showCreditLimitAlertMessage
  }
}